import React from 'react';

function NotFound() {
  return <>Error404</>;
}

export default NotFound;
